
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[company_slug]/oferta",
      function () {
        return require("private-next-pages/[company_slug]/oferta/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[company_slug]/oferta"])
      });
    }
  